<app-loader [fullScreen]="true" [hide]="isHideLoader"></app-loader>
<ng-container *ngIf="unsupportedBrowserText; then unsupportedBrowser; else supportedBrowser">
</ng-container>
<ng-template #unsupportedBrowser>
  <p [style.padding.px]="10">{{ unsupportedBrowserText }}</p>
</ng-template>
<ng-template #supportedBrowser>
  <router-outlet (activate)="getMainComponentElement($event)"></router-outlet>
</ng-template>